import SecureResidenceSubFrame from './SecureResidenceSubFrame';
import { panelByFrameId } from '../../utils/secureResidenceFlow';

const panel = panelByFrameId('frame-35')!;

export default function Frame35() {
  return <SecureResidenceSubFrame panel={panel} />;
}
